import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PromoActions, PromoApiService } from '@promo/data-access';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class PromoEffects {
  loadPromo$: Observable<PromoActions.PromoLoadSuccess | PromoActions.PromoLoadFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(PromoActions.LOAD_PROMO),
      map((action: PromoActions.PromoLoad) => action.payload),
      switchMap((baseStoreCode) => {
        return this.promoApiService.getPromoData(baseStoreCode).pipe(
          map((res) => new PromoActions.PromoLoadSuccess(res)),
          catchError((error: unknown) => of(new PromoActions.PromoLoadFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private promoApiService: PromoApiService,
  ) {}
}
